import { formatDate, money, paymentLabel } from "@/lib/format";
import { PhotoThumb } from "@/components/scan/Scan";

export function EntryRow({ entry, actions, showCreator = false }) {
  const income = entry.type === "income";
  return (
    <div className="flex items-start gap-3 px-4 py-3.5" data-testid={`entry-row-${entry.id}`}>
      <div className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${income ? "bg-emerald-500" : "bg-rose-500"}`} />
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline justify-between gap-3">
          <div className="font-semibold text-sm truncate">{entry.vendor || entry.category_name}</div>
          <div className={`font-num text-sm font-semibold whitespace-nowrap ${income ? "text-emerald-700" : "text-rose-600"}`} data-testid={`entry-amount-${entry.id}`}>
            {income ? "+" : "−"}{money(entry.amount_cents)}
          </div>
        </div>
        <div className="mt-0.5 text-xs text-muted-foreground flex flex-wrap gap-x-2 gap-y-0.5">
          <span>{formatDate(entry.date)}</span>
          <span>· {entry.category_name}{entry.category_archived ? " (archived)" : ""}</span>
          <span>· {paymentLabel(entry.payment_method)}</span>
          {showCreator && <span>· by {entry.created_by_name}</span>}
        </div>
        {entry.description && <div className="mt-1 text-xs text-foreground/70 break-words">{entry.description}</div>}
        {entry.photo_id && <div className="mt-2"><PhotoThumb photoId={entry.photo_id} size="h-12 w-12" testId={`entry-photo-${entry.id}`} /></div>}
        {actions && <div className="mt-2 flex gap-2">{actions}</div>}
      </div>
    </div>
  );
}
